// extracted by css-extract-rspack-plugin
export default {"variation":"WHqpReAxmIvw4WtK","tooltipTarget":"otnjl8REl6o6Fc4S","color":"BKDBfY69l2kU7gH6"};